<template>
  <c-row>
    <c-col sm="12">
      <c-card>
        <c-card-header>
          <c-icon name="cil-grid" />
          Advanced
          <c-link href="https://coreui.io/vue/docs/components/table" target="blank">
            CDataTable
          </c-link>
          application
        </c-card-header>
        <demo-table />
      </c-card>
      <c-card>
        <c-card-header>
          Backend integration example
        </c-card-header>
        <backend-table />
      </c-card>
      <c-card>
        <c-card-header>
          Current table items download to xlsx/csv table
        </c-card-header>
        <download-table />
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
import BackendTable from './BackendTable';
import DemoTable from './DemoTable';
import DownloadTable from './DownloadTable';

export default {
  name: 'AdvancedTables',
  components: {
    BackendTable,
    DemoTable,
    DownloadTable,
  },
};
</script>
